import React from 'react'
import {connect} from 'react-redux'

import {
  PAY_AS_YOU_GO_VALUE
} from './config/constants'

import requestImmediateSession from './data/setters/request_immediate_session'

import isAvailableForImmediateSession from './data/helpers/is_available_for_immediate_session'

import SessionBookConfirmationImmediate from './session_book_confirmation_immediate'
import SessionBookLater from './session_book_later'

class SessionBooker extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedSessionLength: null,
      selectedBookForm: 'now'
    }

    this.onSessionLengthSelect = this.onSessionLengthSelect.bind(this)
    this.onSessionBook = this.onSessionBook.bind(this)
    this.onBookFormImmediateClick = this.onBookFormImmediateClick.bind(this)
    this.onBookFormLaterClick = this.onBookFormLaterClick.bind(this)
  }

  componentWillMount () {
    this.setState({selectedBookForm: 'now'})
  }

  onSessionLengthSelect (e) {
    let length = parseInt(e.target.value, 10)

    if (typeof(length) === 'number') {
      this.setState({selectedSessionLength: length})
    }
  }

  onSessionBook (e) {
    e.preventDefault()

    this.props.onSessionImmediateBook(
      this.props.expert.get('uid'),
      this.props.currentUser.get('uid'),
      this.state.selectedSessionLength
    )

    this.setState({sessionRequestData: {
      type: 'immediate',
      sessionLength: this.state.selectedSessionLength
    }})
  }

  onBookFormImmediateClick (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.setState({selectedBookForm: 'now'})
  }

  onBookFormLaterClick (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.setState({selectedBookForm: 'later'})
  }

  onBookFormClick (section) {
    if (section === 'now') return this.onBookFormImmediateClick
    else if (section === 'later') return this.onBookFormLaterClick
  }

  isBookFormSectionActive (section) {
    if (section === 'now') {
      return isAvailableForImmediateSession(this.props.expertPresence) && this.state.selectedBookForm === 'now' ? true : false
    }
    else if (section === 'later') {
      return !isAvailableForImmediateSession(this.props.expertPresence) || this.state.selectedBookForm === 'later' ? true : false
    }
  }

  renderBookOptions () {
    return (
      <div className='button-group large success'>
        <button className={this.isBookFormSectionActive('now') ? 'active' : ''} onClick={this.onBookFormClick('now')} disabled={!isAvailableForImmediateSession(this.props.expertPresence)}>Now</button>
        <button className={this.isBookFormSectionActive('later') ? 'active' : ''} onClick={this.onBookFormClick('later')}>Later</button>
      </div>
    )
  }

  renderBookSubmit () {
    if (this.state.selectedSessionLength) {
      return (
        <button className='button success' onClick={this.onSessionBook} style={{width: 250}}>Request</button>
      )
    }
    else {
      return (
        <button className='button success' disabled style={{width: 250}}>Request</button>
      )
    }
  }

  renderBookFormImmediate () {
    return (
      <div className='gray-box'>
        <p>Expert is available for immediate session.</p>
        <div className='form'>
          <div className='form-section'>
            <select onChange={this.onSessionLengthSelect} value={this.state.selectedSessionLength} style={{width: 250}}>
              <option key={-1} value='' disabled selected>Select your session length</option>
              <option key={PAY_AS_YOU_GO_VALUE} value={PAY_AS_YOU_GO_VALUE}>Pay as you go</option>
              {
                this.props.sessionLengths.map((s) => {
                  return <option key={s.get('value')} value={s.get('value')}>{s.get('label')}</option>
                })
              }
            </select>
          </div>
          <div className='form-section'>
            {this.renderBookSubmit()}
          </div>
        </div>
      </div>
    )
  }

  renderBookFormLater () {
    return (
      <div className='gray-box'>
        <SessionBookLater
          expert={this.props.expert}
          currentUser={this.props.currentUser}
          onSessionBook={this.props.onSessionBook}/>
      </div>
    )
  }

  renderBookForm () {
    if (isAvailableForImmediateSession(this.props.expertPresence) && this.state.selectedBookForm === 'now') {
      return this.renderBookFormImmediate()
    }
    else {
      return this.renderBookFormLater()
    }
  }

  render () {
    if (this.state.sessionRequestData && this.state.selectedBookForm === 'now') {
      return (
        <SessionBookConfirmationImmediate
          expert={this.props.expert}
          currentUser={this.props.currentUser}
          bookData={this.state.sessionRequestData}
          onSessionRequestAccepted={this.props.onSessionBook}
          onBookLaterClick={this.onBookFormLaterClick}/>
      )
    }
    else {
      return (
        <div className='book-session'>
          <div className='section'>
            {this.renderBookOptions()}
          </div>
          <div className='section'>
            {this.renderBookForm()}
          </div>
        </div>
      )
    }
  }
}

SessionBooker.defaultProps = {
  onSessionBook: () => {}
}

const mapStateToProps = (state, ownProps) => {
  return {
    expertPresence: state.getIn(['presences', ownProps.expert.get('uid')]),
    sessionLengths: state.getIn(['chatSettings', 'sessionPaymentLengths'])
  }
}

const mapDispatchToProps = () => {
  return {
    onSessionImmediateBook: requestImmediateSession
  }
}

const SessionBookerContainer = connect(
  mapStateToProps, mapDispatchToProps
)(SessionBooker)

export default SessionBookerContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/session_booker.js
 **/